import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import { Redirect } from 'react-router-dom';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import moment from 'moment';
import getLocale from '../../../i18n/getLocale';

class FlightReportRefuelEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      load_flight_report_leg: false,
      id: this.props.flight_report_refuel_edit.id,
      approval_required: 0,
      export_required: 0,
      aircraft_id: this.props.flight_report_refuel_edit.aircraft_id,
      helitank_id: this.props.flight_report_refuel_edit.helitank_id,
      helitank_option: '',
      last_type: 'select',
      aircraft_registration: this.props.flight_report_refuel_edit.aircraft_registration,
      date: this.props.flight_report_refuel_edit.date_str,
      comments: this.props.flight_report_refuel_edit.comments,
      flight_report_id: this.props.flight_report_refuel_edit.flight_report_id,
      flight_report_leg_id: this.props.flight_report_refuel_edit.flight_report_leg_id,
      maintenance_association: this.props.flight_report_refuel_edit.maintenance_association,
      extra_flight: this.props.flight_report_refuel_edit.extra_flight,
      internal_storage_tank: this.props.flight_report_refuel_edit.internal_storage_tank,
      fuel_supplier_id: this.props.flight_report_refuel_edit.fuel_supplier_id,
      location_id: this.props.flight_report_refuel_edit.location_id,
      refuel_reason_id: this.props.flight_report_refuel_edit.refuel_reason_id,
      quantity: this.props.flight_report_refuel_edit.quantity,
      receit: this.props.flight_report_refuel_edit.receit,
      auto_receit: this.props.flight_report_refuel_edit.auto_receit,
      requested: this.props.flight_report_refuel_edit.requested,
      company_id: this.props.flight_report_refuel_edit.company_id,
      address: this.props.flight_report_refuel_edit.address,
      staff_id: this.props.flight_report_refuel_edit.staff_id,
      fueling_started: this.props.flight_report_refuel_edit.fueling_started,
      fueling_finished: this.props.flight_report_refuel_edit.fueling_finished,
      next_location_id: this.props.flight_report_refuel_edit.next_location_id,
      truck_no: this.props.flight_report_refuel_edit.truck_no,
      your_sale_no: this.props.flight_report_refuel_edit.your_sale_no,
      previous_sale_no: this.props.flight_report_refuel_edit.previous_sale_no,
      your_sale_no_str: this.props.flight_report_refuel_edit.your_sale_no_str,
      previous_sale_no_str: this.props.flight_report_refuel_edit.previous_sale_no_str,
      water_check_before: this.props.flight_report_refuel_edit.water_check_before,
      water_check_during: this.props.flight_report_refuel_edit.water_check_during,
      water_check_after: this.props.flight_report_refuel_edit.water_check_after,
      reading_finish: this.props.flight_report_refuel_edit.reading_finish,
      reading_start: this.props.flight_report_refuel_edit.reading_start,
      fuel_type: this.props.flight_report_refuel_edit.fuel_type,
      fuel_type_id: this.props.flight_report_refuel_edit.fuel_type_id,
      unitary_value: this.props.flight_report_refuel_edit.unitary_value_str,
      total_value: this.props.flight_report_refuel_edit.total_value_str,
      refundable_value: this.props.flight_report_refuel_edit.refundable_value_str,
      final_value: this.props.flight_report_refuel_edit.final_value_str,
      fuel_unity: this.props.fuel_unity,
      flight_reports_select: this.props.flight_reports_select,
      flight_report_legs_select: this.props.flight_report_legs_select,
      flight_report_legs: this.props.flight_report_legs,
      fuel_suppliers_select: this.props.fuel_suppliers_select,
      aircrafts_select: this.props.aircrafts_select,
      helitank_select: this.props.helitank_select,
      locations_select: this.props.locations_select,
      fuel_types_select: this.props.fuel_types_select,
      companies_select: this.props.companies_select,
      refuel_reasons_select: this.props.refuel_reasons_select,
      staff_select: this.props.staff_select,
      water_check_select: [
        {value: 'Clear', label: 'Clear'},
        {value: 'Contaminated', label: 'Contaminated'},
      ],
      disabled_edition: true,
    };

    this.edit = this.edit.bind(this);
    this.enable_fields = this.enable_fields.bind(this);
    this.export_receipt = this.export_receipt.bind(this);
    this.locale = getLocale();
    this.autoFillTime = this.autoFillTime.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleChangeDate (name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      var date = event.target.value;
      var year  = date.split("-")[0];
      var month  = date.split("-")[1];
      var day  = date.split("-")[2];
      change[name] = date;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleToggleExtraFlightChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
      this.setState({
        helitank_id: this.props.flight_report_refuel_edit.helitank_id,
        helitank_option: '',
        last_type: 'select',
        internal_storage_tank: this.props.flight_report_refuel_edit.internal_storage_tank,
        flight_report_id: null,
        flight_report_leg_id: null,
        next_location_id: null,
        maintenance_association: 0,
      });

    } else {
      var value = 0;
      this.setState({
        helitank_id: '',
        helitank_option: '',
        last_type: 'select',
        internal_storage_tank: 0,
        flight_report_id: null,
        flight_report_leg_id: null,
        next_location_id: null,
        maintenance_association: 0,
      });
    }
    change[name] = value;
    this.setState(change);

    //Anula os campos de internal storage, relatório de voo, trecho, localidade de destino e associação a voo de manutenção
    
  }
  handleToggleInternalStorageChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
      this.setState({
        helitank_id: this.props.flight_report_refuel_edit.helitank_id,
        helitank_option: '',
        last_type: 'select',
        aircraft_id: null,
        flight_report_id: null,
        flight_report_leg_id: null,
        next_location_id: null,
        maintenance_association: 0,
      });
    } else {
      var value = 0;
      this.setState({
        helitank_id: '',
        helitank_option: '',
        last_type: 'select',
        aircraft_id: null,
        flight_report_id: null,
        flight_report_leg_id: null,
        next_location_id: null,
        maintenance_association: 0,
      });
    }
    change[name] = value;
    this.setState(change);

    //Anula os campos de aeronave, relatório de voo, trecho, localidade de destino e associação a voo de manutenção

  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeReport(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      
      var self = this;
      self.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      
      var flight_report_id = event.value;
      if(self.state.flight_report_legs[flight_report_id]) {
          change['flight_report_legs_select'] = self.state.flight_report_legs[flight_report_id];
      } else {
          change['flight_report_legs_select'] = [];
      }
      
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/basic/'+flight_report_id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            aircraft_id: responseJson.data.aircraft_id,
            fuel_type_id: responseJson.data.aircraft.aircraft_model.fuel_type_id,
            fuel_unity: responseJson.data.aircraft.aircraft_model.fuel_unity.abbreviation,
          });
          self.handleSelectChange('fuel_type_id', {'value': self.state.fuel_type_id});
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeAircraft(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      
      var header = this.refs.request_api.header('application/json');
      var self = this;
      self.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aeronave/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            aircraft_id: responseJson.data.main.id,
            fuel_type_id: responseJson.data.main.aircraft_model.fuel_type_id,
            fuel_unity: '('+responseJson.data.main.aircraft_model.fuel_unity.abbreviation+')',
          });
          self.handleSelectChange('fuel_type_id', {'value': self.state.fuel_type_id});
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleChangeGallonsReading (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
    
    if (name == 'reading_start') {
      var start = event.target.value;
    } else {
      var start = this.state.reading_start;
    }
    if (name == 'reading_finish') {
      var finish = event.target.value;
    } else {
      var finish = this.state.reading_finish;
    }
    var delivered = (parseInt(finish) - parseInt(start));
    this.setState({quantity: delivered});
  }
  handleSelectChangeLeg(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/trecho/localidade/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            locations_select: responseJson.data.locations_select,
            location_id: responseJson.data.flight_report_leg.departure_location_id,
            next_location_id: responseJson.data.flight_report_leg.arrival_location_id,
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeFuelSupplier(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fornecedor/combustivel/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            approval_required: responseJson.data.main.refuel_approval_required,
            export_required: responseJson.data.main.refuel_export_required,
            your_sale_no: responseJson.data.flight_report_refuel_data.your_sale_no,
            previous_sale_no: responseJson.data.flight_report_refuel_data.previous_sale_no,
            your_sale_no_str: responseJson.data.flight_report_refuel_data.your_sale_no_str,
            previous_sale_no_str: responseJson.data.flight_report_refuel_data.previous_sale_no_str,
            auto_receit: responseJson.data.flight_report_refuel_data.auto_receit,
            receit: responseJson.data.flight_report_refuel_data.receit,
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeCompany(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/empresa/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            address: responseJson.data.main.address + ', ' + responseJson.data.main.city + ', ' + responseJson.data.main.province,
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }

  changeLastInput(type) {
    this.setState({
      last_type: type,
    });
  }

  // LM
  componentWillReceiveProps(newProps) {
    var self = this;
    if(typeof this.state.id === 'undefined' || this.state.loaded !== 1) {
        this.setState({
            id: newProps.flight_report_refuel_edit.id,
            aircraft_id: newProps.flight_report_refuel_edit.aircraft_id,
            helitank_id: newProps.flight_report_refuel_edit.helitank_id,
            aircraft_registration: newProps.flight_report_refuel_edit.aircraft_registration,
            file_export: newProps.flight_report_refuel_edit.file,
            date: newProps.flight_report_refuel_edit.date_str,
            flight_report_id: newProps.flight_report_refuel_edit.flight_report_id,
            comments: newProps.flight_report_refuel_edit.comments,
            flight_report_leg_id: newProps.flight_report_refuel_edit.flight_report_leg_id,
            maintenance_association: newProps.flight_report_refuel_edit.maintenance_association,
            extra_flight: newProps.flight_report_refuel_edit.extra_flight,
            internal_storage_tank: newProps.flight_report_refuel_edit.internal_storage_tank,
            fuel_supplier_id: newProps.flight_report_refuel_edit.fuel_supplier_id,
            location_id: newProps.flight_report_refuel_edit.location_id,
            quantity: newProps.flight_report_refuel_edit.quantity,
            receit: newProps.flight_report_refuel_edit.receit,
            auto_receit: newProps.flight_report_refuel_edit.auto_receit,
            requested: newProps.flight_report_refuel_edit.requested,
            company_id: newProps.flight_report_refuel_edit.company_id,
            refuel_reason_id: newProps.flight_report_refuel_edit.refuel_reason_id,
            address: newProps.flight_report_refuel_edit.address,
            staff_id: newProps.flight_report_refuel_edit.staff_id,
            fueling_started: newProps.flight_report_refuel_edit.fueling_started,
            fueling_finished: newProps.flight_report_refuel_edit.fueling_finished,
            next_location_id: newProps.flight_report_refuel_edit.next_location_id,
            truck_no: newProps.flight_report_refuel_edit.truck_no,
            your_sale_no: newProps.flight_report_refuel_edit.your_sale_no,
            previous_sale_no: newProps.flight_report_refuel_edit.previous_sale_no,
            your_sale_no_str: newProps.flight_report_refuel_edit.your_sale_no_str,
            previous_sale_no_str: newProps.flight_report_refuel_edit.previous_sale_no_str,
            water_check_before: newProps.flight_report_refuel_edit.water_check_before,
            water_check_during: newProps.flight_report_refuel_edit.water_check_during,
            water_check_after: newProps.flight_report_refuel_edit.water_check_after,
            reading_finish: newProps.flight_report_refuel_edit.reading_finish,
            reading_start: newProps.flight_report_refuel_edit.reading_start,
            fuel_type: newProps.flight_report_refuel_edit.fuel_type,
            fuel_type_id: newProps.flight_report_refuel_edit.fuel_type_id,
            unitary_value: newProps.flight_report_refuel_edit.unitary_value_str,
            total_value: newProps.flight_report_refuel_edit.total_value_str,
            refundable_value: newProps.flight_report_refuel_edit.refundable_value_str,
            final_value: newProps.flight_report_refuel_edit.final_value_str,
            fuel_unity: newProps.fuel_unity,
            flight_report_legs_select: newProps.flight_report_legs_select,
            flight_report_legs: newProps.flight_report_legs,
            flight_reports_select: newProps.flight_reports_select,
            fuel_suppliers_select: newProps.fuel_suppliers_select,
            aircrafts_select: newProps.aircrafts_select,
            helitank_select: newProps.helitank_select,
            locations_select: newProps.locations_select,
            fuel_types_select: newProps.fuel_types_select,
            companies_select: newProps.companies_select,
            staff_select: newProps.staff_select,
            refuel_reasons_select: newProps.refuel_reasons_select,
            loaded: 1,
        });
        if (typeof newProps.flight_report_refuel_edit.flight_report_id !== 'undefined') {
          // Atualiza os dados do relatório
          var change = {};
          var flight_report_id = newProps.flight_report_refuel_edit.flight_report_id;
          if(newProps.flight_report_legs[flight_report_id]) {
              change['flight_report_legs_select'] = newProps.flight_report_legs[flight_report_id];
          } else {
              change['flight_report_legs_select'] = [];
          }
          self.setState(change);
        }
      }

      if (typeof newProps.flight_report_refuel_edit.fuel_supplier_id !== 'undefined' && this.state.loaded === 1 && this.state.load_fuel_supplier !== 1) {
        //Atualiza os dados do fornecedor de combustível
        var header = this.refs.request_api.header('application/json');
        var fuel_supplier_id = newProps.flight_report_refuel_edit.fuel_supplier_id;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/fornecedor/combustivel/'+ fuel_supplier_id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({
              approval_required: responseJson.data.main.refuel_approval_required,
              export_required: responseJson.data.main.refuel_export_required,
              load_fuel_supplier: 1,
            });
          });
        });
      }

      if (typeof newProps.flight_report_refuel_edit.flight_report_leg_id !== 'undefined' && this.state.loaded === 1 && this.state.load_flight_report_leg !== 1) {
        // Atualiza os dados do trecho
        var header = this.refs.request_api.header('application/json');
        var flight_report_leg_id = newProps.flight_report_refuel_edit.flight_report_leg_id;
        if (flight_report_leg_id >= 1) {
          Promise.resolve(header).then(function(value) {
            fetch(config.get('api') + '/relatorio/voo/trecho/localidade/'+ flight_report_leg_id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              self.setState({
                locations_select: responseJson.data.locations_select,
                load_flight_report_leg: 1,
              });
            });
          });
        }
      }
  }

  enable_fields() {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id
    }
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/abastecimento/edicao/liberar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); self.props.handleAlert(error.message, error.status, 'open');}).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({disabled_edition: false});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete(id) {
    var confirm = window.confirm('Tem certeza que gostaria de forçar a exclusão do abastecimento?');
    if (confirm) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
            id: this.state.id,
        };
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then((value) => {
            fetch(config.get('api') + '/relatorio/voo/abastecimento/exclusao', {
                method: 'DELETE',
                mode: 'cors',
                headers: value,
                body: JSON.stringify(datasave),
            })
                .then((response) => response.json())
                .catch((error) => {
                    console.error(error);
                    this.refs.request_api.handleAlert(error.message, 'error', 'open');
                })
                .then((responseJson) => {
                  this.refs.request_api.validate(responseJson, 'alert');
                  if (responseJson.status === 'success') {
                      this.setState({ redirect_url: '/abastecimentos' });
                  }
                  this.props.handleAlert(responseJson.message, responseJson.status, 'open');
              }).catch((error) => {
                  console.error(error);
              });
        });
    }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    // var datasave = new FormData();
    // var imagedata = document.querySelector(".input-nf-file").files[0];
    // datasave.append("file", imagedata);
    var datasave = {
      helitank_id: this.state.helitank_id,
      helitank_option: this.state.helitank_option,
      last_type: this.state.last_type,
      id: this.state.id,
      aircraft_id: this.state.aircraft_id,
      date: this.state.date,
      comments: this.state.comments,
      flight_report_id: this.state.flight_report_id,
      flight_report_leg_id: this.state.flight_report_leg_id,
      maintenance_association: this.state.maintenance_association,
      extra_flight: this.state.extra_flight,
      internal_storage_tank: this.state.internal_storage_tank,
      fuel_supplier_id: this.state.fuel_supplier_id,
      location_id: this.state.location_id,
      quantity: this.state.quantity,
      receit: this.state.receit,
      requested: this.state.requested,
      company_id: this.state.company_id,
      refuel_reason_id: this.state.refuel_reason_id,
      address: this.state.address,
      staff_id: this.state.staff_id,
      fueling_started: this.state.fueling_started,
      fueling_finished: this.state.fueling_finished,
      next_location_id: this.state.next_location_id,
      truck_no: this.state.truck_no,
      your_sale_no: this.state.your_sale_no,
      previous_sale_no: this.state.previous_sale_no,
      water_check_before: this.state.water_check_before,
      water_check_during: this.state.water_check_during,
      water_check_after: this.state.water_check_after,
      reading_finish: this.state.reading_finish,
      reading_start: this.state.reading_start,
      fuel_type_id: this.state.fuel_type_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio/voo/abastecimento/editar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); self.props.handleAlert(error.message, error.status, 'open');}).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  autoFillTime (name) {

    var now = moment(new Date());
    now = now.format("HH:mm");
    var change = {};
    change[name] = now;

    this.setState(change);
  }

  formFields(fields_type) {

    var fields = '';

    if (fields_type == 0) {
      fields = (
        <div className="row">
          <div className="col-md-3 form-group">
            <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Motivo}:</label>
            <Select
              className="form-field-name"
              name="refuel_reason_id"
              value={this.state.refuel_reason_id}
              searchable={true}
              placeholder={'Selecione'}
              onChange={this.handleSelectChange.bind(this, 'refuel_reason_id')}
              options={this.state.refuel_reasons_select}
              required
            />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelSolicitado} ({this.state.fuel_unity}):</label>
              <InputMask value={this.state.requested} maskChar={null} name="requested" mask={this.state.internal_storage_tank == 1 ? "" : "9999"} className="form-control" onChange={this.handleChange.bind(this, 'requested')} placeholder="" required />
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NumeroDaCe}:</label>
              <input type="text" name="receit" className="form-control" placeholder="" value={this.state.receit} onChange={this.handleChange.bind(this, 'receit')} required {...(this.state.auto_receit && {disabled: true})}/>
          </div>
          <div className="col-md-3 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelAbastecido}:</label>
              <InputMask value={this.state.quantity} maskChar={null} name="quantity" mask="9999" className="form-control" onChange={this.handleChange.bind(this, 'quantity')} placeholder="" required />
          </div>
        </div>
      );
    } else {
      fields = (
        <div>
          <div className="row">
            <div className="col-md-3 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Motivo}:</label>
              <Select
                className="form-field-name"
                name="refuel_reason_id"
                value={this.state.refuel_reason_id}
                searchable={true}
                placeholder={'Selecione'}
                onChange={this.handleSelectChange.bind(this, 'refuel_reason_id')}
                options={this.state.refuel_reasons_select}
                required
              />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelSolicitado} ({this.state.fuel_unity}):</label>
                <InputMask value={this.state.requested} maskChar={null} name="requested" mask={this.state.internal_storage_tank == 1 ? "" : "9999"} className="form-control" onChange={this.handleChange.bind(this, 'requested')} placeholder="" required disabled={this.state.disabled_edition} />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Endereco}</label>
                <input type="text" name="address" className="form-control" placeholder="" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} required disabled={this.state.disabled_edition} />
            </div>
            {(this.state.extra_flight == 0) &&
              <div className="col-md-3 form-group">
                  <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Comandante}</label>
                  <Select
                    className="form-field-name"
                    name="staff_id"
                    value={this.state.staff_id}
                    searchable={true}
                    placeholder={'Selecione'}
                    onChange={this.handleSelectChange.bind(this, 'staff_id')}
                    options={this.state.staff_select}
                    disabled={this.state.disabled_edition}
                  />
              </div>
            }
          </div>

          <div className="row">
            {(this.state.extra_flight == 0) &&
              <div className="col-md-3 form-group">
                  <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ProximaLocalidade}:</label>
                  <Select
                    className="form-field-name"
                    name="next_location_id"
                    value={this.state.next_location_id}
                    searchable={true}
                    placeholder={'Selecione'}
                    onChange={this.handleSelectChange.bind(this, 'next_location_id')}
                    options={this.state.locations_select}
                    disabled={this.state.disabled_edition}
                  />
              </div>
            }
            {/* <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NumeroCaminhao}:</label>
                <input type="number" name="truck_no" className="form-control" placeholder="999" value={this.state.truck_no} onChange={this.handleChange.bind(this, 'truck_no')} required />
            </div> */}
            <div className="col-md-3 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NotaFiscal}:</label>
              <input type="text" name="receit" className="form-control" placeholder="" value={this.state.receit} onChange={this.handleChange.bind(this, 'receit')} required {...(this.state.auto_receit ? {disabled: true} : this.state.disabled_edition ? {disabled: true} : '')} />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.SeuNumeroDeVenda}:</label>
                <input type="text" name="your_sale_no_str" className="form-control" placeholder="" value={this.state.your_sale_no_str} onChange={this.handleChange.bind(this, 'your_sale_no_str')} disabled={this.state.disabled_edition} />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NumeroDeVendaAnterior}:</label>
                <input type="text" name="previous_sale_no_str" className="form-control" placeholder="" value={this.state.previous_sale_no_str} onChange={this.handleChange.bind(this, 'previous_sale_no_str')} disabled={this.state.disabled_edition} />
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ChecagemDeAguaAntes}:</label>
                <Select
                  className="form-field-name"
                  name="water_check_before"
                  value={this.state.water_check_before}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'water_check_before')}
                  options={this.state.water_check_select}
                  disabled={this.state.disabled_edition}
                />
            </div>
            <div className="col-md-4 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ChecagemDeAguaDurante}:</label>
                <Select
                  className="form-field-name"
                  name="water_check_during"
                  value={this.state.water_check_during}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'water_check_during')}
                  options={this.state.water_check_select}
                  disabled={this.state.disabled_edition}
                />
            </div>
            <div className="col-md-4 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ChecagemDeAguaDepois}:</label>
                <Select
                  className="form-field-name"
                  name="water_check_after"
                  value={this.state.water_check_after}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'water_check_after')}
                  options={this.state.water_check_select}
                  disabled={this.state.disabled_edition}
                />
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.InicioAbastecimento}:</label>
                <InputMask value={this.state.fueling_started} maskChar={null} name="fueling_started " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'fueling_started')} placeholder="hh:mm" disabled={this.state.disabled_edition} />
            </div>
            <div className="col-md-2 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Click}</label>
              <button type="button" className="btn btn-primary btn-sm form-control" onClick={() => {this.autoFillTime('fueling_started')}} disabled={this.state.disabled_edition}><i className="fa fa-angle-double-left"></i> <i className="fa fa-fw fa-clock-o"></i></button>
            </div>
            <div className="col-md-4 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.TerminoAbastecimento}:</label>
                <InputMask value={this.state.fueling_finished} maskChar={null} name="fueling_finished " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'fueling_finished')} placeholder="hh:mm" disabled={this.state.disabled_edition} />
            </div>
            <div className="col-md-2 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Click}</label>
              <button type="button" className="btn btn-primary btn-sm form-control" onClick={() => {this.autoFillTime('fueling_finished')}} disabled={this.state.disabled_edition}><i className="fa fa-angle-double-left"></i> <i className="fa fa-fw fa-clock-o"></i></button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.LeituraInicial}:</label>
                <InputMask value={this.state.reading_start} maskChar={null} name="reading_start" className="form-control" onChange={this.handleChangeGallonsReading.bind(this, 'reading_start')} placeholder="9999" required disabled={this.state.disabled_edition} />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.LeituraFinal}:</label>
                <InputMask value={this.state.reading_finish} maskChar={null} name="reading_finish" className="form-control" onChange={this.handleChangeGallonsReading.bind(this, 'reading_finish')} placeholder="9999" disabled={this.state.disabled_edition}/>
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Entregues}:</label>
                <InputMask value={this.state.quantity} maskChar={null} name="quantity" className="form-control" onChange={this.handleChange.bind(this, 'quantity')} placeholder="9999" required disabled={this.state.disabled_edition} />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.TipoCombustivel}:</label>
                <Select
                  className="form-field-name"
                  name="fuel_type_id"
                  value={this.state.fuel_type_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'fuel_type_id')}
                  options={this.state.fuel_types_select}
                  required
                  disabled={this.state.internal_storage_tank == 0 ? true : false}
                />
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ValorUnitario}:</label>
                <input value={this.state.unitary_value} name="unitary_value" className="form-control" onChange={this.handleChange.bind(this, 'unitary_value')} placeholder="9999,99" disabled />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ValorTotal}:</label>
                <input value={this.state.total_value} name="total_value" className="form-control" onChange={this.handleChange.bind(this, 'total_value')} placeholder="9999,99" disabled />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ValorReembolsavel}:</label>
                <input value={this.state.refundable_value} name="refundable_value" className="form-control" onChange={this.handleChange.bind(this, 'refundable_value')} placeholder="9999,99" disabled />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ValorFinal}:</label>
                <input value={this.state.final_value} name="final_value" className="form-control" onChange={this.handleChange.bind(this, 'final_value')} placeholder="9999,99" disabled />
            </div>
          </div>
        </div>
      );
    }

    return fields;

  }

  export_receipt() {
    var url = '/files/refuels/' + this.state.id + '_' + this.state.file_export;
    window.open(config.get('cdn') + url);
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <h3 className="page-title pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.dados}</h3>
    
  {/* <button className="btn btn-success btn-sm pull-right" onClick={() => this.export_receipt()}><i className="fa fa-fw fa-download"></i></button> */}
  {(this.state.disabled_edition && this.state.export_required !== 0) &&
    <div>
      <button className="button-inline btn btn-warning btn-sm pull-right" onClick={() => this.enable_fields()}><i className="fa fa-unlock"></i> <span className="hidden-xs hidden-sm">{this.locale.RelatorioAbastecimento.EditarAbastecimento.liberarEdicao}</span></button>
      <button className="button-inline btn btn-sm btn-danger pull-right" onClick={() => this.delete(this.state.id)}><i className="fa fa-fw fa-trash"></i> <span className="hidden-xs hidden-sm">{this.locale.RelatorioAbastecimento.EditarAbastecimento.ForcarExclusao}</span></button>
    </div>
  }
  <div className="clearfix"></div>
  <hr/>
  <form onSubmit={this.edit}>
      <div className="row">
        <div className="col-md-2 form-group">
          <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Data}:</label>
          <InputMask value={this.state.date} name="date" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder={this.locale.general.diaMesAno} required />
        </div>
        <div className="col-md-3 form-group">
          <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Fornecedor}:</label>
          <Select
            className="form-field-name"
            name="fuel_supplier_id"
            value={this.state.fuel_supplier_id}
            searchable={true}
            placeholder={'Selecione'}
            onChange={this.handleSelectChangeFuelSupplier.bind(this, 'fuel_supplier_id')}
            options={this.state.fuel_suppliers_select}
            required
          />
        </div>
        <div className="col-md-3 form-group">
          <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Empresa}:</label>
          <Select
            className="form-field-name"
            name="company_id"
            value={this.state.company_id}
            searchable={true}
            placeholder={'Selecione'}
            onChange={this.handleSelectChangeCompany.bind(this, 'company_id')}
            options={this.state.companies_select}
            required
          />
        </div>
        <div className="col-md-2 form-group">
          <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.AbastecimentoExtraVoo}?</label>
          <br/>
          <Toggle
            checked={this.state.extra_flight}
            name="extra_flight"
            onChange={this.handleToggleExtraFlightChange.bind(this, 'extra_flight')}
          />
        </div>
        {(this.state.extra_flight === 1) &&
          <div className="col-md-2 form-group">
            <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.TanqueArmazenamentoInterno}?</label>
            <br/>
            <Toggle
              checked={this.state.internal_storage_tank}
              name="internal_storage_tank"
              onChange={this.handleToggleInternalStorageChange.bind(this, 'internal_storage_tank')}
            />
          </div>
        }
        {/* <div className="col-md-3 form-group">
          <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.AnexarNotaFiscal}:</label>
          <input type="file" name="file" className="form-control input-nf-file" value={this.state.file} onChange={this.handleChange.bind(this, 'file')} />
        </div> */}
      </div>
      <div className="row">
        <div className="col-md-12 form-group">
            <label>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioAdicionarAbastecimento.Comentarios}:</label>
            <textarea name="comments" className="form-control" placeholder="" value={this.state.comments} onChange={this.handleChange.bind(this, 'comments')} required></textarea>
        </div>
      </div>

      {(this.state.extra_flight === 1) ?
          <div className="row">
            {(this.state.internal_storage_tank === 1) && (
                  self.state.last_type === 'input' ?
                    <div className="col-md-6 form-group">
                      <label>Helitank: <button type="button" onClick={() => {self.changeLastInput('select')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-refresh"></i></button></label>
                      <br/>
                      <input type="text" name="helitank_option" className="form-control" placeholder="" value={this.state.helitank_option} onChange={this.handleChange.bind(this, 'helitank_option')} required />
                    </div>
                  : 
                    <div className="col-md-6 form-group">
                        <label>Helitank: <button type="button" onClick={() => {self.changeLastInput('input')}} className="btn btn-xs btn-info"><i className="fa fa-fw fa-plus"></i></button></label>
                          <br/>
                          <Select
                            className="form-field-name"
                            name="helitank_id"
                            value={this.state.helitank_id}
                            onChange={this.handleSelectChange.bind(this, 'helitank_id')}
                            options={this.state.helitank_select}
                            placeholder={'Selecione'}
                          />
                    </div>
            )}
            {(this.state.internal_storage_tank === 0) &&
              <div className="col-md-4 form-group">
                  <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Aeronave}:</label>
                  <Select
                      className="form-field-name"
                      name="aircraft_id"
                      value={this.state.aircraft_id}
                      searchable={true}
                      placeholder={this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.placeholder.SelecioneAeronave}
                      onChange={this.handleSelectChangeAircraft.bind(this, 'aircraft_id')}
                      options={this.state.aircrafts_select}
                      required
                  />
              </div>
            }
            <div className="col-md-4 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Localidade}:</label>
                <Select
                  className="form-field-name"
                  name="location_id"
                  value={this.state.location_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'location_id')}
                  options={this.state.locations_select}
                  required
                />
            </div>
            {(this.state.internal_storage_tank === 0) &&
              <div className="col-md-4 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.AssociarManutencao}?</label>
                <br/>
                <Toggle
                  checked={this.state.maintenance_association}
                  name="maintenance_association"
                  onChange={this.handleToggleChange.bind(this, 'maintenance_association')}
                />
              </div>
            }
          </div>
        :
          <div className="row">
            <div className="col-md-4 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Relatorio}:</label>
              <Select
                  className="form-field-name"
                  name="flight_report_id"
                  value={this.state.flight_report_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChangeReport.bind(this, 'flight_report_id')}
                  options={this.state.flight_reports_select}
                  required
              />
            </div>
            <div className="col-md-4 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Trecho}:</label>
              <Select
                  className="form-field-name"
                  name="flight_report_leg_id"
                  value={this.state.flight_report_leg_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChangeLeg.bind(this, 'flight_report_leg_id')}
                  options={this.state.flight_report_legs_select}
                  required
              />
            </div>
            <div className="col-md-4 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Localidade}:</label>
              <Select
                className="form-field-name"
                name="location_id"
                value={this.state.location_id}
                searchable={true}
                placeholder={'Selecione'}
                onChange={this.handleSelectChange.bind(this, 'location_id')}
                options={this.state.locations_select}
                required
              />
            </div>
          </div>
      }
      {this.formFields(this.state.export_required)}
      <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> {this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.botaoEditarAbastecimento}</button>
  </form>
</div>
    );
  }
}

export default FlightReportRefuelEditTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReportRefuels/Elements/FlightReportRefuelEditTab.js